import styled from 'styled-components';
import imgDefault from 'images/search.svg';


const IconSearch = styled.img.attrs((props: any) => ({
  src: props.icon || imgDefault,
}))`
  width: 30px;
  height: 30px;
`;

export default IconSearch;
